module.exports = __webpack_public_path__ + "static/img/report3d_img3.75db558c.png";